import script from "./JobCallsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobCallsView.vue?vue&type=script&setup=true&lang=ts"

import "./JobCallsView.vue?vue&type=style&index=0&id=46c0750c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46c0750c"]])

export default __exports__